import { call, put, select, takeEvery } from 'redux-saga/effects';
import * as selectors from '../../../selectors';
import BankTransactionServices from '../../../services/transactionServices';
import * as actions from '../../actions';
import { fetchBankTransactionById } from '../../actions';
import * as actionTypes from '../../actionTypes/ActionTypes';

// Constants for default and initial states
const DEFAULT_STATISTIC_DATA = { statis: Array(13).fill(0) };
const DEFAULT_TRANSACTION_DATA = { total: 0, rows: [] };

const _queryFilter = [
  'year',
  'companyId',
  'companyBankId',
  'from',
  'to',
  'status',
  'pageNumber',
  'pageSize',
  'month',
  'isPrivate',
  'withExchangeAmount',
  'filterAmount',
  'id',
  'sortBy',
  'sortType',
  'keyword',
];

function filterValidParams(input) {
  return Object.keys(input).reduce((acc, key) => {
    if (_queryFilter.includes(key)) {
      acc[key] = input[key];
    }
    return acc;
  }, {});
}


export default function* fetchBankDataSaga() {
  yield takeEvery(actionTypes.BANK.FETCH_BANK_DATA_REQUEST, fetchBankData);
}

export function* fetchBankData(action) {
  try {
    const { payload } = action;
    const company = yield select(selectors.company);
    // Ensure company and companyId exist
    if (!company?.CompanyId) {
      yield put(actions.fetchBankDataSuccess({
        bankStatisticData: DEFAULT_STATISTIC_DATA,
        bankTransactionData: DEFAULT_TRANSACTION_DATA,
      }));
      yield put(actions.setFilterBank(yield select(selectors.filterBank)));
      return;
    }

    const companyId = company.CompanyId;
    let filter = yield select(selectors.filterBank);
    // Apply payload filter if present, otherwise set isCheckAll to false
    filter = payload?.filter ? { ...filter, ...payload.filter } : { ...filter, isCheckAll: false };

    filter.companyId = companyId;

    let yearsData = filter?.years || [];

    // If yearsData is empty, fetch available years from the service
    if (yearsData.length === 0) {
      // Fetch available years for bank data
      const yearsResponse = yield call(BankTransactionServices.getYears, companyId);
      if (yearsResponse.success && yearsResponse.data?.length > 0) {
        yearsData = yearsResponse.data;
      }
    }

    let bankData = {
      bankStatisticData: DEFAULT_STATISTIC_DATA,
      bankTransactionData: DEFAULT_TRANSACTION_DATA,
    };

    // Determine the initial year for the filter
    const storedBankYear = localStorage.getItem('bankYear');
    const isValidStoredYear = storedBankYear && yearsData.some(y => y.value === +storedBankYear) && Number.isFinite(+storedBankYear);
    filter.year = isValidStoredYear ? storedBankYear : (filter.year === null ? yearsData[0]?.value : filter.year || '');

    filter.years = yearsData; // Update filter with available years

    if (filter.id) {
      filter.year = ''; // Clear year filter if ID is present
      delete filter.status;
      yield put(fetchBankTransactionById(filter.id));
    }
    // Construct query filter for bank statistics and transactions
    const queryFilter = filterValidParams(filter);

    if (filter.notRenewStatistic) {
      // If not renewing statistics, skip fetching statistics 
      const bankStatisticData = yield select(selectors.bankStatisticData);
      bankData.bankStatisticData = bankStatisticData || DEFAULT_STATISTIC_DATA;
    } else {
      // Fetch bank statistics
      const bankStatisticDataResponse = yield call(BankTransactionServices.getStatistic, queryFilter);
      if (bankStatisticDataResponse.success) {
        bankData.bankStatisticData = bankStatisticDataResponse.data;
      }
    }

    // Fetch bank transaction data
    const bankTransactionDataResponse = yield call(BankTransactionServices.fetchAll, queryFilter);
    if (bankTransactionDataResponse.success) {
      bankData.bankTransactionData = bankTransactionDataResponse.data;
    }

    // Dispatch success action with fetched data
    yield put(actions.fetchBankDataSuccess(bankData));
    // Update the filter state
    yield put(actions.setFilterBank({ ...filter, notRenewStatistic: false }));
  } catch (error) {
    console.error('Error fetching bank data:', error);
    yield put(actions.fetchBankDataFail(error));
  }
}